export const RATING_CHART_COLOR = {
  RATING_5: "#27C1BC",
  RATING_4: "#5CF1E4",
  RATING_3: "#DDFAF8",
  RATING_2: "#FC88A5",
  RATING_1: "#FD5285"
};
